var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseRoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6447_24069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12C21 7.04 16.96 3 12 3ZM12 19.77C7.71 19.77 4.23 16.28 4.23 12C4.23 7.72 7.72 4.23 12 4.23C16.28 4.23 19.77 7.72 19.77 12C19.77 16.28 16.28 19.77 12 19.77Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2298 8.77003C14.9998 8.54003 14.5898 8.54003 14.3598 8.77003L11.9998 11.13L9.63984 8.77003C9.40984 8.54003 8.99984 8.54003 8.76984 8.77003C8.52984 9.01003 8.52984 9.40003 8.76984 9.64003L11.1298 12L8.76984 14.36C8.52984 14.6 8.52984 14.99 8.76984 15.23C8.99984 15.46 9.40984 15.46 9.63984 15.23L11.9998 12.87L14.3598 15.23C14.4798 15.35 14.6298 15.41 14.7898 15.41C14.9498 15.41 15.1098 15.35 15.2198 15.23C15.4598 14.99 15.4598 14.6 15.2198 14.36L12.8598 12L15.2198 9.64003C15.4598 9.40003 15.4598 9.01003 15.2198 8.77003H15.2298Z",
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6447_24069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRoundIcon);
export default __webpack_public_path__ + "static/media/closeRoundIcon.5d5d4ee4f69b61118f16942642a3c6f5.svg";
export { ForwardRef as ReactComponent };